var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    fillRule: "evenodd",
    d: "M5.636 5.636C8.582 2.691 13.059 2.215 16.5 4.204a1 1 0 0 1-1 1.731 7 7 0 1 0 0 12.13 1 1 0 0 1 1 1.731c-3.441 1.99-7.918 1.514-10.864-1.432a9 9 0 0 1 0-12.728zm12.657 2.657a1 1 0 0 1 1.414 0l1.891 1.891c.179.179.353.352.488.512.148.175.308.396.402.686a2 2 0 0 1 0 1.236 2.02 2.02 0 0 1-.402.687 9.18 9.18 0 0 1-.488.511l-1.89 1.891a1 1 0 0 1-1.415-1.414L19.586 13H12a1 1 0 1 1 0-2h7.586l-1.293-1.293a1 1 0 0 1 0-1.414z",
    clipRule: "evenodd",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOut);
export default __webpack_public_path__ + "static/media/out.5bce89c6c265540fd3dcb23c2e7806de.svg";
export { ForwardRef as ReactComponent };